// ユーザー画面の Stimulus controller が `import { i18n } from 'config/translations'` で読む i18n（#2311 C-2）。
// esbuild の alias でここに向ける（package.json の build:hotwire）。設定は、importmap 用に i18n-js の export で
// template から作っていた translations.js（#2311 C-3 で撤去）と同じ。
import { I18n } from 'i18n-js'
import translations from './translation/translations.json'

const i18n = new I18n()
i18n.store(translations)
i18n.defaultLocale = 'ja'
i18n.enableFallback = true
i18n.locale = document.documentElement.lang

export { i18n }
